export const schedulesRoutes = [
  {
    name: 'schedules',
    path: '/schedules',
    component: () => import('@/modules/schedules/views/Schedules.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
